/*
 * rheincool — Infoband (Infoband-Handoff §3/§5)
 * Wiederholt die Nachricht, bis EINE Spurhälfte breiter als der Viewport
 * ist (nahtlose -50%-Schleife ohne Lücke), verdoppelt die Spur dann für
 * den Umlauf. Alle Kopien außer der ersten aria-hidden — Screenreader
 * lesen den Satz genau einmal.
 */
(() => {
  'use strict';
  if (window.__rcMarquee) return;
  window.__rcMarquee = true;

  const marquee = document.querySelector('[data-marquee]');
  if (!marquee) return;
  const track = marquee.querySelector('[data-marquee-track]');
  const first = marquee.querySelector('[data-marquee-item]');
  if (!track || !first) return;

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!reduced) {
    // Hälfte füllen: so oft wiederholen, dass halfWidth >= Viewport
    let copies = 1;
    while (first.offsetWidth * copies < window.innerWidth && copies < 12) copies += 1;
    for (let i = 1; i < copies * 2; i += 1) {
      const clone = first.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    }
  }

  if (window.rcTrack) window.rcTrack('announcement_view', { nachricht: first.textContent.trim().slice(0, 60) });
})();
